import { MainList } from "@/classes/MainList";
import conditionSearch, {
  ConditionsListParams
} from "@/getinfo-api/conditions";
import { getCurrentCompanyId } from "@/plugins/roles";
import { agentApi } from "@/getinfo-api";
import { Condition as ICondition } from "@/api-v2/agent/models/condition";

export class ConditionsListClass extends MainList {
  params: ConditionsListParams = {
    companyId: getCurrentCompanyId(),
    limit: 30,
    offset: 0,
    sort: "updatedAt",
    order: "DESC"
  };

  constructor(
    params?: ConditionsListParams,
    selectedValue?: string | undefined
  ) {
    super();
    this.method = conditionSearch;
    this.params = { ...this.params, ...params };
    this.baseParams = this.params;
    if (selectedValue) {
      this.singleMethod = () => agentApi.Condition.getCondition(selectedValue);
      this.single();
    }
    this.list();
  }

  search(value: string) {
    this.params.title = value;
    this.params.offset = 0;
    this.listItems = [];
    this.list();
  }

  get conditions(): Array<ICondition> {
    return this.listItems;
  }
}
